const REJECTION_GEOCODE_ERROR = 'The address provided could not be geocoded.';
const getLatitudeAndLongitudeFor = (address, postalCode) => {
  const geoCoder = new google.maps.Geocoder();
  return new Promise((resolve, reject) => {
    geoCoder.geocode({
      componentRestrictions: {
        postalCode
      },
      address
    }, (geocodeResults, status) => {
      if (status === google.maps.GeocoderStatus.OK && geocodeResults && geocodeResults.length > 0) {
        resolve({
          id: geocodeResults[0].place_id,
          lat: geocodeResults[0].geometry.location.lat(),
          lng: geocodeResults[0].geometry.location.lng()
        });
      } else {
        reject(REJECTION_GEOCODE_ERROR);
      }
    });
  });
};

export { REJECTION_GEOCODE_ERROR, getLatitudeAndLongitudeFor };
//# sourceMappingURL=LocationsGeoCoder.js.map
